import { cloneDeep } from 'lodash';

export default class BaseModel {
  static fromObject(objeto) {
    const instancia = new this();
    const objClonado = cloneDeep(objeto);

    Object.keys(instancia).forEach((key) => {
      instancia[key] = objClonado[key] ?? instancia[key];
    });

    return instancia;
  }
}
